// TODO(@flasd): Will this really be our static root?
export const STATIC_ROOT = "https://static.opensea.io"

export const POLYGON_BRIDGE_LINK = "https://wallet.polygon.technology/"
